import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Select } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";

import LoginLayout from "@layout/login-layout";

import { login } from "@services/login-service";
import Patterns from "@/constants/patterns";
import { LoginForm, VendorItem } from "@/types/login-type";
import useUsers from "@hooks/useUsers";
import useUpdateAwsToken from "@/hooks/useUpdateAwsToken";

import styles from "./index.module.less";

export default () => {
  const [form] = Form.useForm();
  const [vendorForm] = Form.useForm();
  const nav = useNavigate();
  let [searchParams] = useSearchParams();
  const { getUserInfoFromLocal, saveUserInfoToLocal } = useUsers();
  const { forceRefreshToken } = useUpdateAwsToken();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [vendorList, setVendorList] = useState<VendorItem[]>([]);

  const onFinish = async (values: LoginForm) => {
    setLoading(true);
    const vendor_id = searchParams.get("vendor_id") || undefined;
    const type = searchParams.get("type") || undefined;
    const ret = await login({ ...values, vendor_id, type });
    setLoading(false);

    saveUserInfoToLocal(ret?.object);

    if (!ret?.result) {
      // message.error(ret?.message);
      return;
    }

    if (!ret?.object?.current_vendor && ret?.object?.vendor_list?.length) {
      setOpen(true);
      setVendorList(ret?.object?.vendor_list || []);
      return;
    }

    if (ret?.object?.change_password) {
      nav("/user/settings/info");
      return;
    }

    if (ret?.object?.current_vendor?.type === "apply")
      return nav("/vendor/details");

    const redirect = searchParams.get("redirect");
    if (redirect) return nav(redirect);

    nav("/home");
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOk = async () => {
    const values = await vendorForm.validateFields().catch(() => {});
    if (!values) return;

    const currentVendor = vendorList.find(
      (vendor) => vendor.id === values.currentVendor
    );

    if (!currentVendor) return;

    const userInfo = getUserInfoFromLocal();
    saveUserInfoToLocal({
      ...(userInfo || {}),
      current_vendor: currentVendor,
    });
    setOpen(false);

    if (userInfo?.change_password) {
      return nav("/user/settings/info");
    }

    if (currentVendor?.type === "apply") return nav("/vendor/details");

    const redirect = searchParams.get("redirect");
    if (redirect) return nav(redirect);

    nav("/home");
  };

  useEffect(() => {
    forceRefreshToken();

    const email = searchParams.get("email");
    const password = searchParams.get("password");

    form.setFieldsValue({
      email: email || "",
      password: password ? window.atob(password) : "",
    });
  }, []);

  return (
    <>
      <LoginLayout
        headerRender={() => (
          <div className={styles.loginHeader}>
            <img
              className={styles.logo}
              src="https://img06.weeecdn.com/cs/image/566/366/7E6538229482E7E9_0x0.webp"
            />
            {/* 功能待开发 */}
            {/* <Button type="primary" ghost className={styles.apply} size="large">
            Apply as supplierer
          </Button> */}
          </div>
        )}
        mainFormRender={() => (
          <div className={styles.formWrapper}>
            <Form
              className={styles.form}
              size="large"
              form={form}
              onFinish={onFinish}
            >
              <h1 className={styles.header}>Welcome Back</h1>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    pattern: Patterns.EMAIL,
                    message: "Incorrect email!",
                    validateTrigger: "blur",
                  },
                ]}
              >
                <Input placeholder="Email" className={styles.input} />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter the password!",
                  },
                ]}
              >
                <Input.Password
                  placeholder="Password"
                  className={styles.input}
                />
              </Form.Item>
              <Button block type="primary" htmlType="submit" loading={loading}>
                Login
              </Button>
              <span
                className={styles.forget}
                onClick={() => nav("/forget-password")}
              >
                Forget Password?
              </span>
            </Form>
          </div>
        )}
      ></LoginLayout>
      <Modal
        title="Select your vendor"
        open={open}
        onCancel={handleCancel}
        onOk={handleOk}
      >
        <Form size="large" form={vendorForm}>
          <Form.Item
            name="currentVendor"
            rules={[
              {
                required: true,
                message: "Please select your vendor!",
              },
            ]}
          >
            <Select placeholder="Please select" style={{ width: "100%" }}>
              {vendorList?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
